import React from "react"
import { Pencil, Trash } from "react-bootstrap-icons"
import { Currency } from "../../util/numbers"
import { PayoutDistribution } from "./types"
import { td, tdLabel } from "./constants"

interface Props {
  distributions: PayoutDistribution[]
  isReadOnly: boolean
  onEdit: (dist: PayoutDistribution) => void
  onRemove: (id: number) => void
}

const DistributionRows: React.FC<Props> = ({ distributions, isReadOnly, onEdit, onRemove }) => {
  if (distributions.length === 0) return null

  return (
    <tbody>
      {distributions.map((dist) => (
        <tr key={dist.id} className="border-b border-gray-200">
          <td className={tdLabel}>Payout Dist</td>

          {/* Desktop: name, email/pending email, and role each in their own column */}
          <td className={`${td} hidden lg:table-cell`}>{dist.band_name}</td>
          <td className={`${td} hidden lg:table-cell`}>
            {dist.recipient_email || dist.pending_band_email || ""}
          </td>
          <td className={`${td} hidden lg:table-cell`}>{dist.role || ""}</td>

          {/* Mobile: name, email/pending email, and role stacked in one column */}
          <td className={`${td} table-cell lg:hidden`} colSpan={3}>
            <div>{dist.band_name}</div>
            <div className="text-gray-600 text-xs">
              {dist.recipient_email || dist.pending_band_email || ""}
            </div>
            {dist.role && <div className="text-gray-600 text-xs">{dist.role}</div>}
          </td>

          <td className={`${td} text-right`}>
            <div className="font-bold text-red-600">{Currency(dist.amount)}</div>
            {!isReadOnly && dist.status === "initialized" && (
              <div className="flex items-center justify-end gap-2 mt-1">
                <button
                  onClick={() => onEdit(dist)}
                  className="text-gray-500 hover:text-black"
                  title="Edit"
                >
                  <Pencil size={16} />
                </button>
                <button
                  onClick={() => onRemove(dist.id)}
                  className="text-red-500 hover:text-red-700"
                  title="Remove"
                >
                  <Trash size={16} />
                </button>
              </div>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  )
}

export default DistributionRows
